module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/updown-5b1be0884ce147fc15f4517fd3ff3985.svg";